(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('PessoaDialogController', PessoaDialogController);

    PessoaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Pessoa', 'Propriedade', 'User', 'Pessoapropriedade', 'Cooperativa', 'Unidade'];

    function PessoaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Pessoa, Propriedade, User, Pessoapropriedade, Cooperativa, Unidade) {
        var vm = this;

        vm.pessoa = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.checkboxes = {};
        //vm.propriedades = Propriedade.query({
        //    size: 50
        //});

        vm.onSucessoNomes = onSucessoNomes;
        vm.listaNomes = Propriedade.queryNomesPropriedadeParceiros({size: 1000, sort:"nomepropriedade,asc"}, onSucessoNomes);
        
        vm.onSucessoPropriedadesAssociadas = onSucessoPropriedadesAssociadas;
        vm.listaPropriedadesAntigas = null;
        
        vm.onSucessoPPs = onSucessoPPs;
        vm.listaPPs = null;

        vm.unidades = Unidade.query(
            {size:1000}
        );
        vm.Preparo = Preparo;

        vm.propriedades = Propriedade.queryNomesPropriedadeParceiros({
            size:1000, sort:"nomepropriedade,asc"
        }, function(data){
            vm.checkboxes = {};
            for (var index = 0; index < data.length; index++) {
                var id = data[index].id;
                vm.checkboxes[id] = false;
            }

            if(vm.pessoa.id != null){
                console.log("Executando first");
                var idPes = parseInt(vm.pessoa.id);
                Propriedade.queryPropriedadesAssociadas({idpessoa:idPes, size:1000}, vm.onSucessoPropriedadesAssociadas); 
                Pessoapropriedade.queryPPsAssociadas({idpessoa: idPes, size:1000}, vm.onSucessoPPs);
            }
            else{
                vm.pessoa.propriedade = [];
            }
        });

        function onSucessoPropriedadesAssociadas(result){
            vm.listaPropriedadesAntigas = result;
            vm.pessoa.propriedade = result;

            for (var index = 0; index < result.length; index++) {
                const id = result[index].id;
                vm.checkboxes[id] = true;
            }

            console.log(vm.listaPropriedadesAntigas);
            console.log(">>");
            console.log(vm.pessoa.propriedade);
        }
        
        function onSucessoPPs(result){
        	vm.listaPPs = result;
        }

        
        
        vm.cooperativas = null;
        vm.cooperativa = null;
        
        /*
        vm.changeCooperativa = function (){
        	console.log("Cooperativa alterada!");
        	if(vm.cooperativa != ""){
        		console.log(vm.cooperativa);
        		vm.pessoa.propriedade = null;
        		Propriedade.queryPropriedadesCooperativa({idcooperativa: vm.cooperativa}, 
        				function(result){
        					vm.pessoa.propriedade = result;
        	        		console.log(vm.pessoa.propriedade);
        				}
        		);
        	}
        	else{
        		console.log("Não selecionada!");
        	}
        };
        */

        vm.changeUnidade = function (){
            console.log("Unidade alterada!");
        };

        vm.changeCheckbox = function(p){
            if(vm.checkboxes[p.id] == true){
                vm.pessoa.propriedade.push(p);
            }
            else {
                vm.pessoa.propriedade = vm.pessoa.propriedade.filter( function(prop) {return prop.id != p.id;} );
            }
        }
        
        /*Cooperativa.query({size:1000}, onSuccessCooperativas);*/
        	
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSucessoNomes(){
        }

       
        function save () {
            vm.isSaving = true;
            if (vm.pessoa.id !== null) {
                var id_unidade = parseInt(vm.pessoa.unidade);
                vm.pessoa.unidade = new Unidade();
                vm.pessoa.unidade.id = id_unidade;
                Pessoa.update(vm.pessoa, vm.Preparo);
            } else {
                vm.novousuario = new User();
                vm.novousuario.login = vm.pessoa.login;
                vm.novousuario.firstName = vm.pessoa.nome;
                vm.novousuario.lastName = vm.pessoa.sobrenome; 
                vm.novousuario.email = vm.pessoa.email;
                vm.novousuario.authorities = [];
                if(vm.pessoa.cargo == 'proprietario'){
                    vm.novousuario.authorities = ['ROLE_PROPRIETARIO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'engagronomo'){
                    vm.novousuario.authorities = ['ROLE_ENGENHEIRO_AGRONOMO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'funcadmin'){
                    vm.novousuario.authorities = ['ROLE_FUNC_ADMINISTRATIVO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'funcoperac'){
                    vm.novousuario.authorities = ['ROLE_FUNC_OPERACIONAL', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'gestor'){
                    vm.novousuario.authorities = ['ROLE_GESTOR_PROP', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'tecnicocampo'){
                    vm.novousuario.authorities = ['ROLE_TECNICO_CAMPO', 'ROLE_USER'];
                }
                else if(vm.pessoa.cargo == 'gestorparceiro'){
                    vm.novousuario.authorities = ['ROLE_GESTOR_PARCEIROS', 'ROLE_USER'];
                }


                if(vm.pessoa.cargo!='cooperado'){
                    User.save(vm.novousuario, onSaveUser);
                }
                else {
                    vm.onSaveUser();
                }
            }
        }

        vm.onSaveUser = onSaveUser;
        vm.quantidadePPs = null;
        vm.onSavePP = onSavePP;
        vm.pessoa_id = null;
        vm.PPsDelete = [];
        vm.PPsUpdate = [];
        vm.PPsCreate = [];

        function onSaveUser(){
            var id_unidade = parseInt(vm.pessoa.unidade);
            vm.pessoa.unidade = new Unidade();
            vm.pessoa.unidade.id = id_unidade;
            Pessoa.save(vm.pessoa, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.pessoa_id = result.id;
            vm.quantidadePPs = vm.pessoa.propriedade.length;
            vm.PPatual = 0;

            if(vm.pessoa.propriedade.length > 0){
                var VetorPPs = [];

                for(var i=0; i<vm.pessoa.propriedade.length; i++){
                    var PP = new Pessoapropriedade();
                    PP.pessoa = new Pessoa();
                    PP.propriedade = new Propriedade();

                    PP.pessoa.id = vm.pessoa_id;
                    PP.propriedade.id = vm.pessoa.propriedade[i].id;

                    VetorPPs.push(PP);
                }

                Pessoapropriedade.acao({acao: "create"}, VetorPPs, vm.onSavePP); 

                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
            else{
                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        function onSavePP() { 

        }

        function Preparo(){
            var idPes = parseInt(vm.pessoa.id);
            Propriedade.queryPropriedadesAssociadas({idpessoa:idPes, size:1000}, function (data){
                vm.listaPropriedadesAntigas = data;
                onUpdateSuccess();
            });
        }
        
        function onUpdateSuccess(result){
        	console.log("PPs");
        	console.log(vm.listaPPs);
        	console.log("Props Antigas");
            console.log(vm.listaPropriedadesAntigas);
            console.log("Props atuais");
            console.log(vm.pessoa.propriedade);

            vm.PPsDelete = [];
            
			var sumiu = null;
        	
        	for (var i = 0; i < vm.listaPropriedadesAntigas.length; i++) {
        		
        		var idPropriedadeAnterior = vm.listaPropriedadesAntigas[i].id;
        		sumiu = true;
				
				for (var j = 0;  j < vm.pessoa.propriedade.length; j++) {
					var comparativo = vm.pessoa.propriedade[j].id;
					
					if(idPropriedadeAnterior == comparativo){
						sumiu = false;
						break;
					}	
				}
			
				if(sumiu == true){
					for(var j = 0; j < vm.listaPPs.length; j++){
						var idPropriedade = vm.listaPPs[j].propriedade.id ;
						if(idPropriedade == idPropriedadeAnterior){
                            var temp = new Pessoapropriedade();
                            temp.id = vm.listaPPs[j].id;
							vm.PPsDelete.push(temp);
						}
					}
				}
        	}
        	
            var existia = null;
            vm.PPsUpdate = [];
            vm.PPsCreate = [];
        	
        	for (var i = 0; i < vm.pessoa.propriedade.length; i++) {
        		
        		var idComparativo = vm.pessoa.propriedade[i].id;
        		existia = false;
				
				for (var j = 0;  j < vm.listaPropriedadesAntigas.length; j++) {
					var idPropriedadeAntiga = vm.listaPropriedadesAntigas[j].id;
					
					if(idComparativo == idPropriedadeAntiga){
						existia = true;
						break;
					}	
				}
			
				if(existia == false){
					var novo = new Pessoapropriedade();
					novo.propriedade = new Propriedade();
					novo.pessoa = new Pessoa();
					novo.propriedade.id = idComparativo;
					novo.pessoa.id = vm.pessoa.id;
					vm.PPsCreate.push(novo);
				}
            }
            
            console.log(vm.PPsCreate);
            console.log(vm.PPsDelete);

            if(vm.PPsDelete.length > 0 && vm.PPsCreate.length > 0){
                console.log("Caso1");
                Pessoapropriedade.acao({acao: "delete"}, vm.PPsDelete, function(){
                    console.log("Delete");
                    Pessoapropriedade.acao({acao: "create"}, vm.PPsCreate, function(){
                        console.log("Create");
                        $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                        $uibModalInstance.close(result);
                        vm.isSaving = false;    
                    });
                });
            }
            else if(vm.PPsDelete.length > 0){
                console.log("Caso2");

                Pessoapropriedade.acao({acao: "delete"}, vm.PPsDelete, function(){
                    console.log("Delete");
                    $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                    $uibModalInstance.close(result);
                    vm.isSaving = false;    
                });
            }
            else if(vm.PPsCreate.length > 0){
                console.log("Caso3");

                Pessoapropriedade.acao({acao: "create"}, vm.PPsCreate, function(){
                    console.log("Create");
                    $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                    $uibModalInstance.close(result);
                    vm.isSaving = false;    
                });
            }
            else{
                console.log("Caso4");

                console.log("fechando");
                $scope.$emit('netWordAgroApp:pessoaUpdate', result);
                $uibModalInstance.close(result);
                vm.isSaving = false;  
            }

        	
        	
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setFoto = function ($file, pessoa) {
            if ($file && $file.$error === 'pattern') {
                return;
            }
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        pessoa.foto = base64Data;
                        pessoa.fotoContentType = $file.type;
                    });
                });
            }
        };
        
        function onSuccessCooperativas(result){
        	vm.cooperativas = result;
        }
        
       

    }
})();
